import type { ApiClient } from "../api/client";
import { computeSeverityCounts, type Finding } from "./audit-data";

export interface AiApiDeps { readonly apiClient: ApiClient; }
export interface AiMessageDto { readonly role: "user" | "assistant"; readonly text: string; }
export interface FindingSummaryItemDto { readonly checkId: string; readonly title: string; readonly category: string; readonly severity: string; }
export interface FindingsSummaryDto {
  readonly score: number;
  readonly counts: { readonly critical: number; readonly high: number; readonly medium: number; readonly low: number };
  readonly failing: readonly FindingSummaryItemDto[];
}
interface AnalyzeResponse { readonly text: string; }

export function buildFindingsSummary(findings: readonly Finding[], score: number): FindingsSummaryDto {
  const failing = findings
    .filter((f) => f.status === "fail")
    .map((f) => ({ checkId: f.check.id, title: f.check.title, category: f.check.category, severity: f.check.severity }));
  return { score, counts: computeSeverityCounts(findings), failing };
}

export async function analyze(deps: AiApiDeps, body: { summary: FindingsSummaryDto; messages: readonly AiMessageDto[] }): Promise<string> {
  const res = await deps.apiClient.post<AnalyzeResponse>("/gw/ai/analyze", body);
  return res.text;
}
